export default __webpack_public_path__ + "static/media/gallery-9-2.c35be339.webp";